export default function BackIcon()
{
      return (
            <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
            >
                  <path
                        d="M10.3128 2.4107V1.20289C10.3128 1.0982 10.1925 1.04039 10.1112 1.10445L3.06745 6.60601C3.00761 6.65256 2.95918 6.71215 2.92587 6.78025C2.89256 6.84836 2.87524 6.92317 2.87524 6.99898C2.87524 7.0748 2.89256 7.14961 2.92587 7.21771C2.95918 7.28582 3.00761 7.34541 3.06745 7.39195L10.1112 12.8935C10.194 12.9576 10.3128 12.8998 10.3128 12.7951V11.5873C10.3128 11.5107 10.2768 11.4373 10.2175 11.3904L4.59245 6.99976L10.2175 2.60758C10.2768 2.5607 10.3128 2.48726 10.3128 2.4107Z"
                        fill="var(--color-icon-btn-action-footer)"
                  />
            </svg>
      );
}
